import { IFinanceiroRepository } from "../../domain/repositories/financeiro_repositories";
import { IFinanceiroService } from "../services/financeiro_service";
import { ContasReceberLista } from '../../domain/models/contas_receber_lista';
import { Paginated } from '../../../../common/domain/models/paginated_models';
import { ContasReceberListaFilter } from '../../domain/models/contas_receber_lista_filter';
import { ContasReceberCopiaForm } from '../../presentation/schemas/ContasReceber_lista/ContasReceber_copia';
import { ContasRecebimentoForm } from '../../presentation/schemas/ContasReceber_lista/ContasReceber_recebimento';
import { ContaReceber } from "../../domain/models/conta_receber";
import { ContaReceberParcialForm } from "../../presentation/schemas/ContasReceber_cadastro/ContasReceberParcial_form";
import { ContasReceberParcial, ContasReceberParcialSituacao } from "../../domain/models/recebimento_parcial";
import { BancoPagamento } from "../../domain/models/banco_pagamento";
import { GetAllContasPagarListaData } from "../daos/read/get_all_contas_pagar_lista";
import { ContasPagarListaFilter } from "../../domain/models/contas_pagar_lista_filter";
import { ContasPagarLista } from "../../domain/models/contas_pagar_lista";
import { ContasPagar } from "../../domain/models/contas_pagar";
import { ContasPagamentoForm } from "../../presentation/schemas/ContasPagar_lista/ContasPagar_pagamento";
import { ContasPagarCopiaForm } from "../../presentation/schemas/ContasPagar_lista/ContasPagar_copia";
import { SaldoBancarioCadastroFilter } from "../../domain/models/saldo_bancario_cadastro_filter";
import { SaldoBancarioCadastroForm } from "../../presentation/schemas/SaldoBancario_cadastro/SaldoBancario_cadastro";
import { SaldoBancarioCadastroLista } from "../../domain/models/saldo_bancario_cadastro_lista";
import { InformacoesBancarias } from "../../domain/models/informacoes_bancarias";
import { IndiceReajuste } from "../../domain/models/indice_reajuste";
import { DropDown } from "../../../../common/domain/models/dropdown";
import { Reajuste } from '../../domain/models/reajuste';
import { ModelContratoFinanceiroLista } from '../../domain/models/contrato_financeiro_lista';
import { ContratoFinanceiro } from '../../domain/models/contrato_financeiro';
import { ModelPgtoContratoFinanceiroLista } from '../../domain/models/pgto_contrato_financeiro_lista';
import { PgtoContratoFinanceiro } from '../../domain/models/pgto_contrato_financeiro';
import { PgtoContratoFinanceiroForm } from '../../presentation/schemas/ContratoFinanceiro_cadastro/PgtoContratoFinanceiro_form';
import { RateioGeralLista } from '../../domain/models/rateio_geral_listas';
import { RateioGeralContaPagar } from '../../domain/models/rateio_geral_conta_pagar';
import { RateioGeralContaPagarLista } from '../../domain/models/rateio_geral_contas_pagar_lista';
import { ContasPagarAnaliticoFilter } from '../../domain/models/contas_pagar_analitico_filter';
import { ContasReceberAnaliticoFilter } from '../../domain/models/contas_receber_analitico_filter';
import { LogReajusteContratoFinanceiro } from '../../domain/models/log_reajuste_contrato_financeiro';
import { ValoresContasMes } from "../../../comercial/domain/models/valores_contas_mes";
import { DashboardFinanceiroInfos } from "../../domain/models/dashboard_financeiro_infos";
import { DashboardFinanceiroChart } from "../../domain/models/dashboard_financeiro_chart";
import { ContasPagarListaCompleto } from "../../domain/models/contas_pagar_lista_all";
import { ContasReceberListaCompleto } from "../../domain/models/contas_receber_lista_all";
import { LogContratoFinanceiroDetalhadoModel } from "../../domain/models/log_contrato_financeiro_detalhado";
import { ContratoMultaJuros } from "../../domain/models/contrato_multa_juros";


export class FinanceiroRepository implements IFinanceiroRepository {
    constructor(
        private readonly service: IFinanceiroService,
    ) { }


    //#region Dashboard Financeiro
    async getDashboardFinanceiroInfos(): Promise<DashboardFinanceiroInfos> {
        return await this.service.getDashboardFinanceiroInfos({});
    }

    async getDashboardFinanceiroChart(ano: number, mes?: number): Promise<DashboardFinanceiroChart[]> {
        const result = await this.service.getDashboardFinanceiroChart({ ano, mes });

        return result.itens.map(item => ({
            mes: item.descMes,
            aPagar: item.aPagar,
            aReceber: item.aReceber,
            pago: item.pago,
            recebido: item.recebido
        }));

    }

    //#endregion


    //#region  CONTAS PAGAR
    async getAllContasPagarLista(
        filter: ContasPagarListaFilter,
        currentPage: number,
        rowsPerPage: number
    ): Promise<ContasPagarListaCompleto> {
        const response = await this.service.getAllContasPagarLista({
            ...filter,
            valor: filter.valor,
            currentPage,
            rowsPerPage
        });

        return {
            indicadores: response.valoresIndice,
            lista: {
                ...response.lista,
                items: response.lista.items.map((item): GetAllContasPagarListaData => ({
                    idContasPagar: item.idContasPagar,
                    status: item.status,
                    nrContasPagar: item.nrContasPagar,
                    nomeCentroCusto: item.nomeCentroCusto,
                    titulo: item.titulo,
                    nomeFornecedor: item.nomeFornecedor,
                    nrOrdemCompra: item.nrOrdemCompra,
                    nrMedicaoTerceirizacao: item.nrMedicaoTerceirizacao,
                    valorPagar: item.valorPagar,
                    valorPago: item.valorPago,
                    dataPagar: item.dataPagar,
                    dataPago: item.dataPago,
                    espacoUtilizado: item.espacoUtilizado,
                    tipoParcela: item.tipoParcela,
                    numeroParcela: item.numeroParcela,

                    deletadaPor: item.deletadaPor,
                    deletadaData: item.deletadaData

                }))
            }
        }
    }


    async getAllContasPagarDeletadas(
        filter: ContasPagarListaFilter,
        currentPage: number,
        rowsPerPage: number
    ): Promise<Paginated<ContasPagarLista>> {
        const response = await this.service.getAllContasPagarDeletadas({
            ...filter,
            valor: filter.valor,
            currentPage,
            rowsPerPage

        });
        return {
            ...response.lista,
            items: response.lista.items.map((item): GetAllContasPagarListaData => ({
                idContasPagar: item.idContasPagar,
                status: item.status,
                nrContasPagar: item.nrContasPagar,
                nomeCentroCusto: item.nomeCentroCusto,
                titulo: item.titulo,
                nomeFornecedor: item.nomeFornecedor,
                nrOrdemCompra: item.nrOrdemCompra,
                nrMedicaoTerceirizacao: item.nrMedicaoTerceirizacao,
                valorPagar: item.valorPagar,
                dataPagar: item.dataPagar,
                dataPago: item.dataPago,
                valorPago: item.valorPago,
                espacoUtilizado: item.espacoUtilizado,

                deletadaPor: item.deletadaPor,
                deletadaData: item.deletadaData

            }))
        };
    }

    async deleteContasPagarByIds(idList: number[], tela: string): Promise<void> {
        await this.service.deleteContasPagarById({ idsList: idList, tela });
    }

    async contasPagamento(form: ContasPagamentoForm): Promise<void> {
        await this.service.contasPagamento({
            ...form,
            idsContasPagar: form.idsContasPagar,
            idBanco: form.idBancoPagamento,

        });
    }

    async copiaContasPagar(form: ContasPagarCopiaForm): Promise<void> {
        await this.service.copiaContasPagar({
            ...form
        });

    }

    async getContasPagarById(idContasPagar: number): Promise<ContasPagar> {
        const response = await this.service.getContaPagarById({ idContasPagar });
        return {
            ...response,
            nrContasPagar: response.nrContasPagar != undefined ? String(response.nrContasPagar) : undefined,
            valorPago: response.valorPago,
            valorPagar: response.valorPagar,
            valorRateio: response.valorRateio
        };
    }

    async createContasPagar(form: ContasPagar): Promise<number> {
        const response = await this.service.createContaPagar({
            ...form,
            idContasPagar: form.idContasPagar ?? 0,
            valorPago: form.valorPago,
            valorPagar: form.valorPagar,
            valorRateio: form.valorRateio,
            nrContasPagar: undefined,
            limparArquivo1: false,
            limparArquivo2: false,
            limparArquivo3: false,

        });
        return response.idContaPagar;
    }

    async updateContasPagar(form: ContasPagar): Promise<number> {
        const response = await this.service.updateContaPagar({
            ...form,
            idContasPagar: form.idContasPagar ?? 0,
            valorPago: form.valorPago,
            valorPagar: form.valorPagar,
            valorRateio: form.valorRateio,
            nrContasPagar: undefined,
            valorMulta: form.valorMulta,
            valorJuros: form.valorJuros,
            limparArquivo1: form.limparArquivo1 ? form.limparArquivo1 : false,
            limparArquivo2: form.limparArquivo2 ? form.limparArquivo2 : false,
            limparArquivo3: form.limparArquivo3 ? form.limparArquivo3 : false,
        });
        return response.idContaPagar;
    }

    async cancelarPagamento(idContasPagar: number): Promise<void> {
        await this.service.cancelarPagamento({ idContasPagar });
    }

    async recuperacaoContasPagar(idsContaPagar: number[]): Promise<void> {
        await this.service.recuperacaoContasPagar({ lista: idsContaPagar });

    }

    async getContasPagarArquivoById(
        idContasPagar: number,
        nroArquivo: number,
    ): Promise<Blob> {
        const response = await this.service.getContasPagarArquivoById({
            idContasPagar,
            nroArquivo,
        });
        return response;
    }


    //#endregion






    //#region CONTAS RECEBER 

    async getAllContasReceberLista(
        filter: ContasReceberListaFilter,
        currentPage: number,
        rowsPerPage: number
    ): Promise<ContasReceberListaCompleto> {

        const response = await this.service.getAllContasReceberLista({
            ...filter,
            currentPage,
            rowsPerPage
        });

        return {
            indicadores: response.valoresIndice,
            lista: {
                ...response.lista,
                items: response.lista.items.map((item): ContasReceberLista => ({
                    idContasReceber: item.idContasReceber,
                    status: item.status,
                    nrContasReceber: item.nrContasReceber,
                    nomeCentroCusto: item.nomeCentroCusto,
                    valorReceber: item.valorReceber,
                    dataReceber: item.dataReceber,
                    dataBaixa: item.dataBaixa,
                    valorBaixa: item.valorBaixa,
                    nrNotaFiscal: item.nrNotaFiscal,
                    nome: item.nome,
                    nomeCliente: item.nomeCliente,
                    nomeSubConta: item.nomeSubConta,
                    nroOrdemCompra: item.nroOrdemCompra,
                    dataCompetencia: item.dataCompetencia,
                    nrParcela: item.nrParcela,
                    nrContrato: item.nrContrato,
                    espacoUtilizado: item.espacoUtilizado
                }))
            }
        }
    }

    async getAllContasReceberDeletadas(
        filter: ContasReceberListaFilter,
        currentPage: number,
        rowsPerPage: number
    ): Promise<Paginated<ContasReceberLista>> {

        const response = await this.service.getAllContasReceberDeletadas({
            ...filter,
            currentPage,
            rowsPerPage
        });

        return {
            ...response.lista,
            items: response.lista.items.map((item): ContasReceberLista => ({
                idContasReceber: item.idContasReceber,
                status: item.status,
                nrContasReceber: item.nrContasReceber,
                nomeCentroCusto: item.nomeCentroCusto,
                valorReceber: item.valorReceber,
                dataReceber: item.dataReceber,
                dataBaixa: item.dataBaixa,
                valorBaixa: item.valorBaixa,
                nrNotaFiscal: item.nrNotaFiscal,
                nome: item.nome,
                nomeCliente: item.nomeCliente,
                nomeSubConta: item.nomeSubConta,
                nroOrdemCompra: item.nroOrdemCompra,
                dataCompetencia: item.dataCompetencia,
                nrParcela: item.nrParcela,
                nrContrato: item.nrContrato,
                espacoUtilizado: item.espacoUtilizado,

                deletadaPor: item.deletadaPor,
                deletadaData: item.deletadaData
            }))
        }
    }

    async deleteContasReceberByIds(idList: number[], tela: string): Promise<void> {
        await this.service.deleteContasReceberById({ idsList: idList, tela });

    }

    async recebimentoContas(form: ContasRecebimentoForm): Promise<void> {
        await this.service.contasRecebimento({ ...form });

    }

    async copiaContasReceber(form: ContasReceberCopiaForm): Promise<void> {
        await this.service.copiaContasReceber({ ...form });

    }

    //Necessário normalizar os valores monetarios para o input de MoneyMask
    async getContaReceberById(idContaReceber: number): Promise<ContaReceber> {
        const response = await this.service.getContaReceberById({ idContaReceber });
        return {
            ...response,
            nrContasReceber: response.nrContasReceber != undefined ? String(response.nrContasReceber) : undefined,
            valorBaixa: response.valorBaixa != undefined ? response.valorBaixa : undefined,
            valorReceber: response.valorReceber != undefined ? response.valorReceber : undefined,
            juros: response.juros != undefined ? response.juros : undefined,
            multa: response.multa != undefined ? response.multa : undefined,
        };
    }


    async createContaReceber(form: ContaReceber): Promise<number> {
        const response = await this.service.createContaReceber({
            ...form,
            nrContasReceber: undefined,
            valorBaixa: form.valorBaixa,
            valorReceber: form.valorReceber,
            juros: form.juros,
            multa: form.multa,

        });
        return response.idContaReceber;
    }

    async cancelarRecebimento(idContaReceber: number): Promise<void> {
        await this.service.cancelarRecebimento({ idContaReceber });
    }

    async updateContaReceber(form: ContaReceber): Promise<number> {
        const response = await this.service.updateContaReceber({
            ...form,
            nrContasReceber: undefined,
            valorBaixa: form.valorBaixa,
            valorReceber: form.valorReceber,
            juros: form.juros,
            multa: form.multa,

        });
        return response.idContaReceber;
    }


    async createContasReceberParcial(form: ContaReceberParcialForm): Promise<ContasReceberParcialSituacao> {
        const response = await this.service.createContasReceberParcial({
            idContasReceber: form.idContasReceber,
            idBancoPagamento: form.idBancoPagamento ?? null,
            formaPagamento: form.formaPagamento ?? null,
            dataBaixa: form.dataBaixa,
            valorBaixa: form.valorBaixa
        })

        return { id: response.id, ultimaConta: response.ultimaConta }

    }

    async deleteContasReceberParcial(id: number): Promise<void> {
        await this.service.deleteContasReceberParcial({ id });

    }

    async getAllContasReceberParcial(idContasReceber: number, page: number, rowsPerPage: number): Promise<Paginated<ContasReceberParcial>> {
        const response = await this.service.getAllContasReceberParcial({ idContasReceber, page, rowsPerPage })
        return {
            ...response,
            items: response.items.map((item): ContasReceberParcial => ({
                idContasReceberParcial: item.idContasReceberParcial ?? 0,
                idContasReceber: item.idContasReceber,
                idBancoPagamento: item.idBancoPagamento,
                nomeBancoPagamento: item.nomeBancoPagamento,
                formaPagamento: item.formaPagamento,
                dataBaixa: item.dataBaixa,
                valorBaixa: item.valorBaixa,
            }))

        }
    };

    async recuperacaoContasReceber(idsContaReceber: number[]): Promise<void> {
        await this.service.recuperacaoContasReceber({ lista: idsContaReceber });

    };

    async getContasReceberArquivoById(
        idContasReceber: number,
        nroArquivo: number,
    ): Promise<Blob> {
        const response = await this.service.getContasReceberArquivoById({
            idContasReceber,
            nroArquivo,
        });
        return response;
    }

    //#endregion 



    //#region BANCO PAGAMENTO

    async getAllBancoPagamentoWithFilters(
        idsBancoPagamento: number[],
        status: number,
        currentPage: number,
        rowsPerPage: number): Promise<Paginated<BancoPagamento>> {

        const response = await this.service.getAllBancoPagamentoWithFilters({
            idsBancoPagamento,
            status,
            currentPage,
            rowsPerPage
        })

        return {
            ...response,
            items: response.items.map((item): BancoPagamento => ({
                idBancoPagamento: item.idBancoPagamento,
                nrConta: item.nrConta,
                nrAgencia: item.nrAgencia,
                nomeBanco: item.nomeBanco,
                ativo: item.ativo,
                controlaSaldo: item.controlaSaldo,
                saldoFinal: item.saldoFinal

            }))
        }
    }

    async getBancoPagamentoById(idBancoPagamento: number): Promise<BancoPagamento> {
        const response = await this.service.getBancoPagamentoById({ idBancoPagamento })
        return response;

    }

    async createBancoPagamento(form: BancoPagamento): Promise<number> {
        const response = await this.service.createBancoPagamento({ ...form })
        return response.idBancoPagamento;

    }

    async updateBancoPagamento(form: BancoPagamento): Promise<void> {
        await this.service.updateBancoPagamento({ ...form })
    }

    async deleteBancoPagamentoById(idBancoPagamento: number): Promise<void> {
        await this.service.deleteBancoPagamentoById({ idBancoPagamento })

    }


    async createSaldoBancario(form: SaldoBancarioCadastroForm): Promise<void> {
        await this.service.createSaldoBancario({
            ...form,
            dataTransferencia: form.dataTransferencia ? form.dataTransferencia : undefined,
            tipo: form.tipo ? 1 : 2,
            valor: form.valor ? form.valor : 0
        })

    }

    async getAllSaldoBancarioLista(
        filter: SaldoBancarioCadastroFilter,
        currentPage: number,
        rowsPerPage: number
    ): Promise<Paginated<SaldoBancarioCadastroLista>> {

        const response = await this.service.getAllSaldoBancarioLista({
            ...filter,
            valor: filter.valor ? filter.valor : undefined,
            currentPage,
            rowsPerPage
        })

        return {
            ...response,
            items: response.items.map((item): SaldoBancarioCadastroLista => ({
                idSaldoBancario: item.idSaldoBancario,
                tipoMovimento: item.tipoMovimento,       // 2 = Débito, 1 = Crédito
                dataMovimento: item.dataMovimento,
                dataPagamento: item.dataPagamento,
                descricao: item.descricao,
                detalhamento: item.detalhamento,         // nr_conta + conta.nome.
                valorMovimento: item.valorMovimento,
                saldoFinal: item.saldoFinal,

            }))
        }
    }

    //#endregion





    //#region INFORMACOES BANCARIAS

    async getInformacoesBancariasFuncionarioById(idFuncionario: number): Promise<InformacoesBancarias | null> {
        const response = await this.service.getInformacoesBancariasFuncionarioById({ id: idFuncionario });
        return { ...response.item };

    }

    async getInformacoesBancariasFornecedorById(idFornecedor: number): Promise<InformacoesBancarias | null> {
        const response = await this.service.getInformacoesBancariasFornecedorById({ id: idFornecedor });
        return { ...response.item };
    }

    //#endregion


    //#region INDICE REAJUSTE

    async getAllIndiceReajusteLista(
        idsIndiceReajuste: number[],
        codigo: number | undefined,
        currentPage: number | undefined,
        rowsPerPage: number | undefined

    ): Promise<Paginated<IndiceReajuste>> {
        const response = await this.service.getAllIndiceReajusteLista({
            idsIndiceReajuste,
            codigo,
            currentPage,
            rowsPerPage
        });
        return {
            ...response,
            items: response.items.map((item): IndiceReajuste => ({
                idIndiceReajuste: item.idIndiceReajuste,
                descricao: item.descricao,
                dataCadastro: item.dataCadastro,
                status: item.status,
                codigo: item.idIndiceReajuste

            }))
        };
    }

    async getIndiceReajusteDropDown(): Promise<DropDown[]> {
        const response = await this.service.getIndiceReajusteDropDown();
        return response;
    };

    async createIndiceReajuste(request: IndiceReajuste): Promise<number> {
        const response = await this.service
            .createIndiceReajuste({
                dataCadastro: request.dataCadastro ?? new Date(),
                descricao: request.descricao ?? ''
            });

        return response.idIndiceReajuste;
    }

    async updateIndiceReajuste(request: IndiceReajuste): Promise<void> {
        await this.service.updateIndiceReajuste({
            idIndiceReajuste: request.idIndiceReajuste,
            status: request.status ?? false,
            descricao: request.descricao ?? ''
        });

    }

    async deleteIndiceReajuste(idIndiceReajuste: number): Promise<void> {
        await this.service.deleteIndiceReajuste({ idIndiceReajuste });
    }

    async getIndiceReajusteById(idIndiceReajuste: number): Promise<IndiceReajuste | null> {
        const response = await this.service.getIndiceReajusteById({ idIndiceReajuste });
        return { ...response };
    }

    //#endregion


    //#region REAJUSTE

    async getAllReajusteLista(
        idIndiceReajuste: number,
        currentPage: number | undefined,
        rowsPerPage: number | undefined,
    ): Promise<Paginated<Reajuste>> {
        const response = await this.service.getAllReajusteLista({
            idIndiceReajuste,
            currentPage,
            rowsPerPage
        });
        return {
            ...response,
            items: response.items.map((item) => ({
                idIndiceReajuste: item.idIndiceReajuste,
                idReajuste: item.idReajuste,
                dataReajuste: item.dataReajuste,
                percentual: item.percentual / 100,
                mesIndice: item.mesIndice,
                status: item.status,
                idsContratosFinanceiroIgnorados: []
            }))
        }
    };

    async createReajuste(request: Reajuste): Promise<void> {

        await this.service.createReajuste({
            idIndiceReajuste: request.idIndiceReajuste,
            dataReajuste: request.dataReajuste ?? new Date(),
            percentual: request.percentual != undefined ? request.percentual / 100 : 0,
            mesIndice: request.mesIndice,
            aplicarEntrada: request.aplicarEntrada ?? true,
            idsContratosFinanceiroIgnorados: request.idsContratosFinanceiroIgnorados

        });

    };

    async updateReajuste(request: Reajuste): Promise<void> {
        await this.service.updateReajuste({
            idReajuste: request.idReajuste,
            idIndiceReajuste: request.idIndiceReajuste,
            dataReajuste: request.dataReajuste ?? new Date(),
            percentual: request.percentual != undefined ? request.percentual / 100 : 0,
            mesIndice: request.mesIndice,
            aplicarEntrada: request.aplicarEntrada ?? true,
            idsContratosFinanceiroIgnorados: request.idsContratosFinanceiroIgnorados

        });
    };

    async deleteReajuste(idReajuste: number): Promise<void> {
        await this.service.deleteReajuste({ idReajuste });

    };

    async getReajusteById(idReajuste: number): Promise<Reajuste | null> {
        const response = await this.service.getReajusteById({ idReajuste });
        return {
            ...response,
            idsContratosFinanceiroIgnorados: [],
            percentual: response.percentual * 100
        };
    };

    async createReajusteContratoIndividual(
        idContratoFinanceiro: number,
        idIndiceReajuste: number,
        aplicarNaEntrada: boolean,
        dataInicioAplicacaoReajuste?: Date,
        dataReajusteDe?: Date,
        dataReajusteAte?: Date,
    ): Promise<void> {
        const request = {
            idContratoFinanceiro,
            idIndiceReajuste,
            aplicarNaEntrada,
            dataInicioAplicacaoReajuste,
            dataReajusteDe,
            dataReajusteAte
        };
        await this.service.createReajusteContratoIndividual(request);
    };

    //#endregion



    //#region CONTRATO FINANCEIRO


    async getAllContratoFinanceiroListaWithFilters(
        idsCliente: number[],
        idsCentroCusto: number[],
        descricao: string | null,
        codigo: number | null,
        dataReceberDe: Date | null,
        dataReceberAte: Date | null,
        status: number[] | null,
        dataInicioDe: Date | null,
        dataInicioAte: Date | null,

        currentPage: number | undefined,
        rowsPerPage: number | undefined
    ): Promise<Paginated<ModelContratoFinanceiroLista>> {

        const response = await this.service.getAllContratoFinanceiroListaWithFilters({
            idsCliente,
            idsCentroCusto,
            descricao,
            codigo,
            dataReceberDe,
            dataReceberAte,
            status,
            dataInicioDe,
            dataInicioAte,

            currentPage: currentPage ?? 1,
            rowsPerPage: rowsPerPage ?? 25,
        });

        return {
            ...response,
            items: response.items.map((item): ModelContratoFinanceiroLista => ({
                idContratoFinanceiro: item.idContratoFinanceiro,
                codigo: item.idContratoFinanceiro,
                idCliente: item.idCliente,
                nomeCliente: item.nomeCliente,
                unidade: item.unidade,
                idCentroCusto: item.idCentroCusto,
                nomeCentroCusto: item.nomeCentroCusto,
                descricao: item.descricao,
                dataInicio: item.dataInicio,
                dataTermino: item.dataTermino,
                valorVenda: item.valorVenda,
                valorTotal: item.valorTotal,
                valorGlobal: item.valorGlobal,
                valorSaldo: item.valorSaldo,
                criadoPor: item.criadoPor,

                status: item.status
            }))
        };
    }

    async getContratoFinanceiroById(idContratoFinanceiro: number): Promise<ContratoFinanceiro> {
        const response = await this.service.getContratoFinanceiroById({ idContratoFinanceiro });
        return {
            ...response,
            valorTotal: response.valorTotal != null ? response.valorTotal : 0,
            valorFinanciadoBanco: response.valorFinanciadoBanco != null ? response.valorFinanciadoBanco : undefined,
            valorGlobal: response.valorGlobal != null ? response.valorGlobal : undefined,
            valorSaldoDevedor: response.valorSaldoDevedor != null ? response.valorSaldoDevedor : undefined,
            valorVenda: response.valorVenda != null ? response.valorVenda : undefined,
        };

    }

    async createContratoFinanceiro(form: ContratoFinanceiro): Promise<number> {
        const response = await this.service.createContratoFinanceiro({
            ...form,
            idContratoFinanceiro: 0,
            valorFinanciadoBanco: form.valorFinanciadoBanco != null ? form.valorFinanciadoBanco : undefined,
            valorGlobal: form.valorGlobal != null ? form.valorGlobal : undefined,
            valorSaldoDevedor: form.valorSaldoDevedor != null ? form.valorSaldoDevedor : undefined,
            valorTotal: form.valorTotal != null ? form.valorTotal : undefined,
            valorVenda: form.valorVenda != null ? form.valorVenda : undefined,
        });
        return response.idContratoFinanceiro;
    }

    async updateContratoFinanceiro(form: ContratoFinanceiro): Promise<void> {
        await this.service.updateContratoFinanceiro({
            ...form,
            idContratoFinanceiro: form.idContratoFinanceiro,
            valorFinanciadoBanco: form.valorFinanciadoBanco != null ? form.valorFinanciadoBanco : undefined,
            valorGlobal: form.valorGlobal != null ? form.valorGlobal : undefined,
            valorSaldoDevedor: form.valorSaldoDevedor != null ? form.valorSaldoDevedor : undefined,
            valorTotal: form.valorTotal != null ? form.valorTotal : undefined,
            valorVenda: form.valorVenda != null ? form.valorVenda : undefined,
            motivo: form.motivo != null ? form.motivo : undefined,
        })

    }

    async deleteContratoFinanceiro(idContrato: number): Promise<void> {
        await this.service.deleteContratoFinanceiro({ idContrato });

    }

    async getAllLogReajusteContratoFinanceiro(
        idContratoFinanceiro: number,

        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<LogReajusteContratoFinanceiro>> {

        const response = await this.service.getAllLogReajusteContratoFinanceiroLista({
            idContratoFinanceiro,
            currentPage: currentPage ?? 1,
            rowsPerPage: rowsPerPage ?? 25,
        });
        return response;
    }

    async getAllLogContratoFinanceiroDetalhado(
        idContratoFinanceiro: number,

        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<LogContratoFinanceiroDetalhadoModel>> {

        const response = await this.service.getAllLogContratoFinanceiroDetalhadoLista({
            idContratoFinanceiro,
            currentPage: currentPage ?? 1,
            rowsPerPage: rowsPerPage ?? 100,
        });
        return response;
    }

    async updateMultaJurosContrato(
        idContratoFinanceiro: number,
        percentualJuros: number,
        percentualMulta: number
    ): Promise<void> {
        await this.service.updateMultaJurosContrato({
            idContratoFinanceiro,
            percentualJuros,
            percentualMulta
        });
    }

    async getMultaJurosContasReceber(
        idContaReceber: number
    ): Promise<ContratoMultaJuros | null> {
        const response = await this.service.getMultaJurosContasReceber({ idContaReceber: idContaReceber });
        return response.item;
    }

    //#endregion




    //#region PAGAMENTO CONTRATO FINANCEIRO

    async getAllPgtoContratoFinanceiroLista(
        idContratoFinanceiro: number,
        currentPage: number | undefined,
        rowsPerPage: number | undefined
    ): Promise<Paginated<ModelPgtoContratoFinanceiroLista>> {
        const response = await this.service.getAllPgtoContratoFinanceiroLista({
            idContratoFinanceiro,
            currentPage: currentPage ?? 1,
            rowsPerPage: rowsPerPage ?? 100,
        });

        return {
            ...response,
            items: response.items.map((item): ModelPgtoContratoFinanceiroLista => ({
                idPgtoContratoFinanceiro: item.idPgtoContratoFinanceiro,
                dataCadastro: item.dataCadastro,
                valorReceber: item.valorReceber != null ? item.valorReceber : undefined,
                dataReceber: item.dataReceber,
                valorRecebido: item.valorRecebido != null ? item.valorRecebido : undefined,
                dataRecebido: item.dataRecebido,
                observacao: item.observacao,
                numeroParcela: item.numeroParcela,
                percentualReajuste: item.percentualReajuste != null ? item.percentualReajuste / 100 : undefined,
                status: item.status,
                valorInicial: item.valorInicial != null ? item.valorInicial : undefined,
                valorFinal: item.valorFinal != null ? item.valorFinal : undefined,
                valorJuros: item.valorJuros != null ? item.valorJuros : undefined,
                valorSemReajuste: item.valorSemReajuste != null ? item.valorSemReajuste : undefined,
                valorSaldoDevedor: item.valorSaldoDevedor != null ? item.valorSaldoDevedor : undefined,
                parcelaSecundaria: item.parcelaSecundaria,
                tipo: item.tipo,
            }))
        };
    }

    async getPgtoContratoFinanceiroById(idPgtoContratoFinanceiro: number): Promise<PgtoContratoFinanceiro> {
        const response = await this.service.getPgtoContratoFinanceiroById({ idPgtoContratoFinanceiro });
        return {
            ...response,
            // valorReceber: response.valorReceber != null ? response.valorReceber : null,
            // valorRecebido: response.valorRecebido != null ? response.valorRecebido : null,
            valorReceber: response.valorReceber != null ? response.valorReceber : null,
            valorRecebido: response.valorRecebido != null ? response.valorRecebido : null,
        };
    }

    async createPgtoContratoFinanceiro(form: PgtoContratoFinanceiroForm): Promise<void> {
        await this.service.createPgtoContratoFinanceiro({
            ...form,
            idContratoFinanceiro: form.idContratoFinanceiro ?? 0,
            valorAParcelar: form.valorAParcelar != null ? form.valorAParcelar : null,
            valorEntrada: form.valorEntrada != null ? form.valorEntrada : null,

        });

    }

    async updatePgtoContratoFinanceiro(
        idPgtoContratofinanceiro: number,
        observacao?: string | null,
        dataReceber?: Date | null,
        valorReceber?: number | null,
        status?: boolean,
        tipo?: number
    ): Promise<void> {
        await this.service.updatePgtoContratoFinanceiro({
            idPgtoContratofinanceiro,
            observacao,
            dataReceber,
            valorReceber,
            status,
            tipo
        });
    }

    async deletePgtoContratoFinanceiroById(idPgtoContratoFinanceiro: number): Promise<void> {
        await this.service.deletePgtoContratoFinanceiroById(idPgtoContratoFinanceiro);
    }

    //#endregion




    //#region RATEIO GERAL


    async getAllRateioGeralContaPagarLista(
        idsCentroCusto: number[],
        nroNotaFiscal?: string | null,
        dataDe?: Date | null,
        dataAte?: Date | null,

        currentPage?: number,
        rowsPerPage?: number

    ): Promise<Paginated<RateioGeralContaPagarLista>> {
        const response = await this.service.getAllRateioGeralContasPagarLista({
            idsCentroCusto,
            nroNotaFiscal,
            dataDe,
            dataAte,

            currentPage: currentPage ?? 1,
            rowsPerPage: rowsPerPage ?? 25,
        });

        return {
            ...response,
            items: response.items.map((item): RateioGeralContaPagarLista => ({
                idContasPagar: item.idContasPagar,
                nroNotaFiscal: item.nroNotaFiscal,
                data: item.data,
                valorRateio: item.valorRateio != null ? item.valorRateio : null,
                nomeCentroCusto: item.nomeCentroCusto,
            })),
        };

    }

    async getAllRateioGeralLista(
        idContasPagar: number,
        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<RateioGeralLista>> {
        const response = await this.service.getAllRateioGeralLista({
            idContasPagar,
            currentPage: currentPage ?? 1,
            rowsPerPage: rowsPerPage ?? 25,
        });

        return {
            ...response,
            items: response.items.map((item): RateioGeralLista => ({
                idRateioGeral: item.idRateioGeral,
                idContasPagar: item.idContasPagar ?? 0,
                nomeCentroCusto: item.nomeCentroCusto,
                valorRateio: item.valorRateio != null ? item.valorRateio : null,
            })),
        };
    }

    async getContaPagarRateioById(idContasPagar: number): Promise<RateioGeralContaPagar> {
        const response = await this.service.getContaPagarRateioById({
            idContasPagar,
        });
        return {
            ...response,
            valorPagar: response.valorPagar != null ? response.valorPagar : null,
        };
    }

    async createRateioGeral(
        idContasPagar: number,
        idsCentroCusto: number[],
    ): Promise<void> {
        await this.service.createRateioGeral({
            idContasPagar,
            idsCentroCusto,
        });
    }

    async updateRateioGeral(
        form: RateioGeralLista[],
    ): Promise<void> {

        await this.service.updateRateioGeral({
            list: form.map((item) => ({
                idRateioGeral: item.idRateioGeral,
                valorRateio: item.valorRateio != null ? item.valorRateio : null,
            })),
        });
    }

    async deleteRateioGeralById(idContasPagar: number): Promise<void> {
        await this.service.deleteRateiosGeralById(idContasPagar);

    }

    //#endregion



    //#region FILTROS CONTA PAGAR

    async getContasPagarAnaliticoFiltros(): Promise<ContasPagarAnaliticoFilter | null> {
        const response = await this.service.getContasPagarAnaliticoFiltros({});
        return response?.item || null;
    }

    async saveContasPagarAnaliticoFiltros(listaColunas: string | null): Promise<void> {
        await this.service.saveContasPagarAnaliticoFiltros({ listaColunas });

    }

    //#endregion




    //#region FILTROS CONTA Receber

    async getContasReceberAnaliticoFiltros(): Promise<ContasReceberAnaliticoFilter | null> {
        const response = await this.service.getContasReceberAnaliticoFiltros({});
        return response?.item || null;
    }

    async saveContasReceberAnaliticoFiltros(listaColunas: string | null): Promise<void> {
        await this.service.saveContasReceberAnaliticoFiltros({ listaColunas });

    }

    async getValoresContasMes(
        dataDe: Date | null,
        dataAte: Date | null,
        tipo: string
    ): Promise<ValoresContasMes> {
        const response = await this.service.getValoresContasMes({
            dataDe,
            dataAte,
            tipo,
        });
        return { ...response };

    };

    //#endregion


}